"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formConfig = {
  name: "comment",
  fields: {
    comment: {
      id: "citizen-comment",
      jsonPath: "actionInfo[0].comments",
      pattern: /^[^\$\"'<>\?~`!&@#$%^+={}\[\]*]{1,500}$/i,
      hintText: "CS_COMMON_COMMENTS_PLACEHOLDER2",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      value: "",
      required: true
    }
  },
  saveUrl: "/rainmaker-pgr/v1/requests/_update",
  redirectionRoute: ""
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/comment.js
// module id = 1974
// module chunks = 895